import { render, staticRenderFns } from "./BetslipManualResultModal.vue?vue&type=template&id=1d1878ee&"
import script from "./BetslipManualResultModal.vue?vue&type=script&lang=js&"
export * from "./BetslipManualResultModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports